(function () {
    'use strict';
    realmCommerceApp.factory('apiService', apiService);

    /*@ngInject*/
    function apiService($http, ENVIRONMENT, loaderService) {
        const urlBase = ENVIRONMENT.baseURL;
        const service = {
            removeCartItem: removeCartItem,
            loadProducts: loadProducts,
            loadOrders: loadOrders,
            getCartPreview: getCartPreview,
            getCart: getCart,
            getCustomerPreview: getCustomerPreview,
            getCustomer: getCustomer,
            addToCart: addToCart,
            addBooklistItemsToCart: addBooklistItemsToCart,
            updateCartItem: updateCartItem,
            productFilterSearch: productFilterSearch,
            defaultSearch: defaultSearch,
            applyVoucher: applyVoucher,
            queryOrder: queryOrder,
            clearCart: clearCart,
            sendForm: sendForm,
            autocomplete: autocomplete,
            removeVoucher: removeVoucher,
            removeVouchers: removeVouchers
        }
        return service;

        function httpExecute(url, method, data, headers, extras, preventSpinner) {
            var defaultHeaders = {
                'Content-Type': 'application/x-www-form-urlencoded'
            };
            var headers = typeof headers !== 'undefined' ? angular.merge(defaultHeaders, headers) : defaultHeaders;
            var extras = typeof extras !== 'undefined' ? extras : null;
            var preventSpinner = typeof preventSpinner !== 'undefined' ? preventSpinner : false;
            var request = {
                url: url,
                method: method,
            };
            if (data != undefined) {
                var data = $.param(data);
                request.data = data;
                request.headers = headers;
            }
            request = angular.merge(request, extras);
            if (!preventSpinner) {
                loaderService.start();
            }
            return $http(request).then(function (response) {
                return response.data;
            }).finally(function () {
                loaderService.stop();
            });
        }

        function addToCart(productId, quantity) {
            var url = '/api/cart/' + productId + '/add-item';
            return httpExecute(url, 'POST', {"quantity": quantity});
        }

        function addBooklistItemsToCart(booklistId) {
            var url = '/api/cart/' + booklistId + '/add-booklist';
            return httpExecute(url, 'POST');
        }

        function getCartPreview() {
            return httpExecute('/api/cart/preview', 'GET');
        }

        function getCart(hideSpinner) {
            return httpExecute('/api/cart/current', 'GET', null, null, null, hideSpinner);
        }

        function getCustomerPreview() {
            return httpExecute('/api/customer/preview', 'GET');
        }

        function getCustomer() {
            return httpExecute('/api/customer/current', 'GET');
        }

        function updateCartItem(itemId, parameters) {
            var url = '/api/cart/' + itemId + '/update-item';
            return httpExecute(url, 'POST', parameters);
        }

        function removeCartItem(cartItemId) {
            var url = '/api/cart/' + cartItemId + '/remove-item';
            return httpExecute(url, 'POST');
        }

        function clearCart() {
            var url = '/api/cart/remove';
            return httpExecute(url, 'POST');
        }

        function loadProducts(limit, start, group, format) {
            var dataType = "html";
            var url = "/api/products/" + group + "/" + start + "/" + limit;
            if (format == "json") {
                dataType = format;
                url = urlBase + "/api/products/" + group + "/" + start + "/" + limit + '/' + format;
            }
            return $http({
                url: url,
                method: "GET",
                dataType: format
            }).then(function (response) {
                return response.data;
            });
        }

        function loadOrders(limit, start) {
            var url = "/api/order/" + start + "/" + limit;
            return httpExecute(url, 'GET');
        }

        // @TODO query order URL
        function queryOrder(orderId, data) {
            return httpExecute(`/api/order/${orderId}/query`, 'POST', {
                'message': data
            });
        }

        function defaultSearch(keyword, modifiers, offset, size, orderby, sortorder, type) {
            var url = '/api/search?term=' + keyword;
            if (modifiers) {
                url += "&modifiers=" + modifiers;
            }
            if (size) {
                url += "&size=" + size;
            }
            if (type) {
                url += "&type=" + type;
            }

            if (orderby) {
                url += "&orderby=" + orderby;
            }
            if (sortorder) {
                url += "&sortorder=" + sortorder;
            }
            if (offset) {
                url += "&page=" + offset;
            }
            return httpExecute(url, 'GET');
        }

        function applyVoucher(voucherCode){
            var url = '/api/voucher/apply/' + voucherCode;
            return httpExecute(url, 'POST');
        }

        function removeVoucher(voucherCode){
            var url = '/api/voucher/remove/' + voucherCode;
            return httpExecute(url, 'POST');
        }

        function removeVouchers(){
            var url = '/api/voucher/remove-all';
            return httpExecute(url, 'POST');
        }

        function productFilterSearch(searchModel, filterSize) {
            let url = '/api/search?type=product&term=' + searchModel.term;
            url += "&page=" + searchModel.pagination.page || 0;
            url += "&size=" + 0;
            if (filterSize) {
                url += "&filterSize=" + filterSize;
            }
            if (searchModel.sortType) {
                url += "&sortType=" + searchModel.sortType;
            }
            if (searchModel.sortOrder) {
                url += "&sortOrder=" + searchModel.sortOrder;
            }
            if (searchModel.modifiers) {
                url += "&modifiers=" + JSON.stringify(searchModel.modifiers);
            }
            return httpExecute(url, 'GET');
        }

        function sendForm(formName, formData){
            return httpExecute('/api/form/' + formName, 'POST', formData);
        }

        function autocomplete(term) {
            return httpExecute(`/api/search/autocomplete`,'GET', {
                params: {
                    term: term,
                    type: "product"
                }
            })
        }

    }
})();


// WEBPACK FOOTER //
// ./static/js/app/services/api.service.js